export const BannerDetails = {
    GET_BANNERDETAILS: "GET_BANNERDETAILS",
    POST_BANNERDETAILS: "POST_BANNERDETAILS",
    UPDATE_BANNERDETAILS: "UPDATE_BANNERDETAILS",
}
